export const TAB_LIST = {PLAYER_LIABILITY: 'playerLiability', PLAYER_BONUS_BALANCE: 'playerBonusBalance',PENDING_WITHDRAWALS: 'pendingWithdrawals'};